module.exports = __webpack_public_path__ + "static/media/22ESCWA13.308a0d5e.jpg";